/* ══════════════════════════════════════════════════════════════════════════
   Shard House — House Experience · Copy Evolution + Transition Pulse
   ══════════════════════════════════════════════════════════════════════════
   Handles what CSS can't: text-content swaps and the global pulse.

   Runs deferred. On load it checks persisted state and applies copy
   changes. Also listens for live house:state-change events so
   real-time transitions (cookie accept → entered) are perceptible.
   ══════════════════════════════════════════════════════════════════════════ */

(function () {
    'use strict';

    /* ── Copy evolution map ───────────────────────────────────────────── */
    /* Each state lists text swaps.  `from` is optional — when present
       only elements whose trimmed textContent matches will be swapped.
       `html: true` uses innerHTML instead of textContent.               */

    var SWAPS = {
        entered: [
            {
                selector: '.slideshow__slide-content .button:not(.outline) span',
                from: 'BEGIN THE EXPERIENCE',
                to: 'EXPLORE THE COLLECTION'
            },
            {
                selector: '[data-sh-access-label]',
                to: 'ACCESS'
            }
        ],
        insider: [
            {
                selector: '.slideshow__slide-content .button:not(.outline) span',
                from: 'BEGIN THE EXPERIENCE',
                to: 'EXPLORE THE COLLECTION'
            },
            {
                selector: '[data-sh-access-label]',
                toAttr: 'data-sh-initials',
                toState: true,
                fallback: 'ACCESS'
            },
            {
                selector: '.sh-teaser__entry-headline',
                to: "YOU'RE INSIDE THE HOUSE"
            },
            {
                selector: '.sh-teaser__entry-message',
                html: true,
                to: "This space evolves with you.<br>Explore what\u2019s been unlocked."
            },
            {
                selector: '.sh-teaser__entry-secondary',
                to: 'Welcome back.'
            },
            {
                selector: '.sh-teaser__continue',
                from: 'BEGIN THE EXPERIENCE',
                to: 'EXPLORE THE COLLECTION'
            }
        ]
    };

    /* ── Crossfade helper ─────────────────────────────────────────────── */
    /* Brief opacity dip before text swap so the change is felt, not seen.
       Duration aligned to --sh-duration-hover (180ms) via JS constant.   */
    var CROSSFADE_MS = 140;

    function crossfade(el, applyContent) {
        el.style.transition = 'opacity ' + CROSSFADE_MS + 'ms ease';
        el.style.opacity = '0';
        setTimeout(function () {
            applyContent();
            el.style.opacity = '1';
            /* Clean up inline style after transition settles */
            setTimeout(function () { el.style.transition = ''; }, CROSSFADE_MS);
        }, CROSSFADE_MS);
    }

    function applySwaps(state, animate) {
        var swaps = SWAPS[state];
        if (!swaps) return;

        swaps.forEach(function (swap) {
            document.querySelectorAll(swap.selector).forEach(function (el) {
                if (swap.from && el.textContent.trim() !== swap.from) return;
                var text = swap.to;
                if (swap.toState && window.shHouse && window.shHouse.getIdentity()) {
                    text = window.shHouse.getIdentity();
                } else if (swap.toAttr) {
                    text = el.getAttribute(swap.toAttr) || swap.fallback || swap.to;
                }
                var finalText = text;
                var apply = function () {
                    if (swap.html) { el.innerHTML = finalText; }
                    else { el.textContent = finalText; }
                };
                if (animate) { crossfade(el, apply); } else { apply(); }
            });
        });
    }

    /* ── Global transition pulse ──────────────────────────────────────── */
    /* Brief opacity breath on #main-content — pairs with CSS keyframes
       in sh-house-experience.css.                                        */

    function pulse() {
        document.documentElement.classList.add('sh-house-transitioning');
        setTimeout(function () {
            document.documentElement.classList.remove('sh-house-transitioning');
        }, 300);  /* Matches --sh-duration-fast (0.25s) + buffer */
    }

    /* ── Live state changes (cookie accept, email signup) ─────────────── */
    document.addEventListener('house:state-change', function (e) {
        pulse();
        applySwaps(e.detail.state, true);   /* animate: crossfade text */
    });

    /* ── ACCESS gateway routing ──────────────────────────────────────── */
    /* The access trigger adapts its click behavior per house state:
       visitor  → opens account drawer (entry prompt)
       entered  → opens account drawer (navigation)
       insider  → routes to Vault if available, else account drawer       */

    function initGateway() {
        /* Event delegation on document (capture phase) ensures this fires
           before Shopify's customer-accounts script or any other handler.
           No timing dependency on when the button enters the DOM. */
        document.addEventListener('click', function (e) {
            var trigger = e.target.closest('[data-sh-access-gateway]');
            if (!trigger) return;

            e.preventDefault();
            e.stopImmediatePropagation();
            var state = window.shHouse ? window.shHouse.state : 'visitor';

            if (state === 'insider' && document.querySelector('[data-vault-url]')) {
                window.location.href = document.querySelector('[data-vault-url]').getAttribute('data-vault-url');
                return;
            }

            /* Default: toggle account drawer (works for visitor + entered) */
            var drawer = document.querySelector('account-drawer');
            if (drawer) {
                if (drawer.classList.contains('active')) {
                    drawer.close();
                } else {
                    drawer.open();
                }
            } else {
                document.dispatchEvent(new CustomEvent('sh:access-requested', {
                    detail: { state: state }
                }));
            }
        }, true);
    }

    /* ── On load: apply copy for persisted (return-visit) state ────────── */
    function init() {
        var state = window.shHouse ? window.shHouse.state : 'visitor';
        if (state !== 'visitor') {
            applySwaps(state, false);  /* return visit: instant, no flash */
        }
        initGateway();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
